import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { useWhileQuizNavigationCheck } from "../context/WhileQuizNavigationCheck";

const Breadcrumb = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const pathnames = location.pathname.split("/").filter((x) => x);
    const {
        isQuizTest,
        isModalOpen,
        setIsModalOpen,
        yesButtonclick,
        noButtonclick,
    } = useWhileQuizNavigationCheck();

    const breadcrumbNameMap = {
        StudentDashboard: "Dashboard",
        Course: "Course Details",
        CourseContent: "Course Content",
        Quiz: "Quiz List",
        QuizContent: "Quiz Content",
    };

    // const handleLinkOnClick = (path) => {
    //     if (isQuizTest) {
    //         /**
    //          * opening the model
    //          */
    //         setIsModalOpen(true);

    //         /**
    //          * if yes onclick then redirect if no then stay
    //          */
    //         if (yesButtonclick) {
    //             navigate(path);
    //         } else if (noButtonclick) {
    //             return null;
    //         }
    //     }
    // };
    return (
        <Box sx={{ paddingBottom: "20px" }}>
            <Breadcrumbs>
                {pathnames.map((value, index) => {
                    const to = `/${pathnames.slice(0, index + 1).join("/")}`;
                    const breadcrumbLabel = breadcrumbNameMap[value] || value;
                    return index === pathnames.length - 1 ? (
                        <Typography color="textPrimary" key={to}>
                            {breadcrumbLabel}
                        </Typography>
                    ) : (
                        <Link
                            component={RouterLink}
                            to={to}
                            color="inherit"
                            key={to}
                            // onClick={(to) => handleLinkOnClick(to)}
                        >
                            {breadcrumbLabel}
                        </Link>
                        // <Typography
                        //     component={RouterLink}
                        //     // to={isQuizTest ? null : to}
                        //     color="inherit"
                        //     key={to}
                        //     onClick={(to) => handleLinkOnClick(to)}
                        // >
                        //     {breadcrumbLabel}
                        // </Typography>
                    );
                })}
            </Breadcrumbs>
        </Box>
    );
};

export default Breadcrumb;
